
import * as actionTypes from "./modalActionTypes";

const setModalAction = (modal: boolean) => (dispatch: any) =>{
    dispatch({ type: actionTypes.SET_MODAL, modal });
}


export { setModalAction };